<template>
    <div>
        <div class="TTL-dialog">
            <el-dialog v-model="param.view" title="新增 / 编辑家庭成员" width="25%" :before-close="closeBefore">
                <el-form :model="form" align="center" v-loading="param.loading">
                    <el-form-item>
                        <div class="TTL-setting-image-detail">
                        <el-image
                            width="150"
                            height="150"
                            :src="param.avar ? param.avar : require('@/assets/avatar/avatar_default.png')"
                            :zoom-rate="1.2"
                            :preview-src-list="param.avar ? [param.avar] : []"
                            :initial-index="4"
                            fit="cover"
                        />
                        <div class="TTL-setting-image-btn">
                        <el-button size="small" type="warning" icon="EditPen" circle  @click="editThumbs" />
                        </div>
                        </div>
                    </el-form-item>
                    <el-form-item>
                    <el-input v-model="param.name" placeholder="请填写家庭成员名称" round size="large" prefix-icon="User" clearable/>
                    </el-form-item>
                    <el-form-item>
                    <el-input v-model="param.birthday" placeholder="请填写家庭成员生日" round size="large" prefix-icon="Cherry" clearable/>
                    </el-form-item>
                    <el-form-item>
                        <div class="TTL-footer">
                            <el-button type="warning" size="large" round @click="saveHomeMember">保存</el-button>
                            <el-button size="large" round @click="closeBefore">取消</el-button>
                        </div>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <!-- 自定义组件 -->
            <!-- 图片上传组件 -->
            <div><input type="file" id="homememberaddoredit" style="display:none;" @change="getgenealogyImageUrl"/></div>

        </div>
    </div>
</template>

<script>
import INTERFACE_MODEL_BASE from '@/Interface/index';
import INTERFACE_MODEL_GENEALOGY from '@/Interface/Genealogy/home';
export default {
    props: ['value','memberid'],
    data() {
        return {
            param: {
                id:'',
                name:'',
                avar:'',
                birthday:'',
                loading:false,
                view:false,
            },

            /** 图片上传 **/
            imageUploadParam: {
                type:'homemember',
                imagetype:'avar',
            },

        }
    },

    watch: {
        value(val) {
            if(val) {
                this.param.view=true;
                this.param.id=this.memberid;
                this.resetparam(); //重置提交参数
                if(this.memberid > 0) this.getHomeMemberInfos();

            }
        }
    },

    methods: {


        /** 获取家族成员信息 **/
        getHomeMemberInfos() {
            this.param.loading=true;
            INTERFACE_MODEL_GENEALOGY.GET_HOME_MEMBER_INFO({id:this.memberid}).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;
                
                //重置提交参数
                this.param.id=res.data.id;
                this.param.name=res.data.name;
                this.param.avar=res.data.avar;
                this.param.birthday=res.data.birthday;
            });
        },


        /** 保存编辑的家庭成员信息 **/
        saveHomeMember() {
            this.param.loading=true;
            INTERFACE_MODEL_GENEALOGY.ADD_OR_EDIT_HOME_MEMBER(this.param).then((res) => {
                this.param.loading=false;
                if(res.status > 0) return false;
                
                //关闭窗口
                this.closeBefore();
            });
        },


        /** 重置提交参数 **/
        resetparam() {
            this.param.id='';
            this.param.name='';
            this.param.avar='';
            this.param.birthday='';
        },


        /** 回调父级函数 **/
        closeBefore() {
            this.param.view=false;
            this.$emit('MemberAddOrEditfinish');
        },


        /** 
         * 编辑头像
        */
        editThumbs() {
            document.getElementById('homememberaddoredit').click();
        },


        /**
         * 获取返回的商品图片url
        */
        getgenealogyImageUrl(e) {
            let _this=this;
            let file=e.target.files[0]; //获取文件
            e.target.value=''; //清空数据

            //上传图片到接口操作
            INTERFACE_MODEL_BASE.UPLOAD_FILES({imageType:_this.imageUploadParam.imagetype,File:file}).then((res) => {
                if(res.status > 0) return false;
                let url=this.$ImageAddress+res.data.url;
                if(_this.imageUploadParam.type=='homemember') _this.param.avar=url; 
            });
        },


    },
}
</script>
<style scoped>
.TTL-dialog {text-align:left !important;}
.TTL-setting-image-detail {width:80px;height:80px;text-align:center;margin:0 auto;}
.TTL-setting-image-detail .el-image {width:80px;height:80px;border-radius:50%;}
</style>